import React, { useEffect, useState } from 'react';
import { Text, View } from '@aws-amplify/ui-react';
import './ConsideredLoading.css';

interface Props {
  eyebrow: string;
  voice: string;
  delayMs?: number;
}

const ConsideredLoading = ({ eyebrow, voice, delayMs = 200 }: Props) => {
  const [visible, setVisible] = useState(delayMs <= 0);

  useEffect(() => {
    if (delayMs <= 0) return;
    const id = setTimeout(() => setVisible(true), delayMs);
    return () => clearTimeout(id);
  }, [delayMs]);

  if (!visible) return null;

  return (
    <View padding="medium" role="status" aria-live="polite">
      <Text role="presentation" color="brand.primary.60" className="considered-loading__eyebrow">
        {eyebrow}
      </Text>
      <Text color="font.tertiary" marginTop="small">
        {voice}
      </Text>
    </View>
  );
};

export default ConsideredLoading;
